import { useContext } from "react";

//Context
import { AuthContext } from "./Auth";

//Librerias
import { useIdleTimer } from "react-idle-timer";

//Cierra la sesión automáticamente tras N minutos de inactividad, sin aviso previo.
const INACTIVITY_TIMEOUT_MINUTES = 20;

const IdleTimerContainer = () => {
    //===============================================================================================================================================
    //========================================== Context ============================================================================================
    //===============================================================================================================================================
    const { cerrarSesion } = useContext(AuthContext);

    //===============================================================================================================================================
    //========================================== Funciones ==========================================================================================
    //===============================================================================================================================================
    const onIdle = () => {
        //Se guarda el motivo en sessionStorage porque este componente se desmonta al redirigir a Login tras cerrarSesion().
        sessionStorage.setItem("strMotivoCierreSesion", "inactividad");
        cerrarSesion();
    };

    useIdleTimer({
        timeout: 1000 * 60 * INACTIVITY_TIMEOUT_MINUTES,
        onIdle,
    });

    return null;
};

export default IdleTimerContainer;
